<template>
  <li
    v-for="(title, hash) in items"
    :key="hash"
  >
    <a :href="hash">
      {{ title }}
    </a>
  </li>
</template>

<script>
export default {
  name: 'MenuItems',

  props: {
    items: {
      required: true,
      type: Object,
    },
  },
};
</script>
